import { render, staticRenderFns } from "./FundsCard.vue?vue&type=template&id=fe3a4792"
import script from "./FundsCard.vue?vue&type=script&lang=js"
export * from "./FundsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports